import { THANKYOU_HINT } from "../constants/constants"
import hompageStyle from "./styles/hompage.module.css"
import circular_logo from "../assets/cirle_logo.png"
import { Link } from "react-router-dom"
import frame from "../assets/frame.png"
export default function ThankyouPage() {

    return <div className={hompageStyle.main}>
        <div className={`${hompageStyle.container2} ${hompageStyle.center}`}>
            <div className={hompageStyle.circulardiv} >
                <img src={circular_logo} alt="circular logo" />
            </div>

            <img src={frame} style={{ position: "absolute", top: 0, left: 0, width: "320px", height: "530px", zIndex: -1 }}></img>

            <div className={hompageStyle.endPage}>
                {THANKYOU_HINT}
            </div>

            <div className={hompageStyle.gradDiv}>

            </div>

            <div style={{ position: "absolute", bottom: 10, fontSize: "10px" }}
            >

                <p> *<Link to={"/t-and-c"} style={{ color: "gold" }}>Terms & Conditions</Link>
                &nbsp;applied
                </p>
            </div>
        </div>
    </div>
}